import { InitiateButton } from '../../../../../../../../../components/initiate-button';
import { useGate } from '../../../../../../../hooks/gate';
import { useChannelsStateStore } from '../../../../../../../store/channels-state';
import { ChannelGateStateType, ChannelType } from '../../../../../../../types';
import { getGateStep } from '../../../../../../../utils/channels/helpers/gate';
import { GateStepIcon } from '../../../gate-step-icon';

type LockStatusControlProps = {
  channel: ChannelType;
  handleAction: () => void;
};

export const LockStatusControl: React.FC<LockStatusControlProps> = ({ channel, handleAction }) => {
  const { gateActive } = useGate(channel);
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as ChannelGateStateType | null;
  const status = getGateStep(state, true);

  return (
    <InitiateButton isOn={false} onClickControl={handleAction} active={gateActive}>
      <GateStepIcon step={status} />
    </InitiateButton>
  );
};
